import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { compose } from "redux";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";

import Header from "common-components/Header";
import { TitleLockup } from "@vds/type-lockups";
import { isMobile } from "utils/style";
import Button from "common-components/Buttons";
import Container from "common-components/Container";

import FetchPageContent from "../../../../hoc/FetchPageContent";

class AuthorizedAgentDeleteInformation extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, customerHistory, informationRequest, deleteRequest } = this.props.breadCrumbs;
      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/authorized-agent" },
        { label: customerHistory, path: "/privacy/secure/authorized-agent/customer" },
        { label: informationRequest, path: "/privacy/secure/authorized-agent/new-request" },
        { label: deleteRequest, path: "/privacy/secure/authorized-agent/delete" }
      ]);
    }
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("authorized agent delete information", this.props.pageContent.sc_pagetitle);
    }
  }

  handleClick = () => {
    this.props.history.push({
      pathname: "/privacy/secure/authorized-agent/multifactor-authentication-primer",
      state: {
        confirmAuth: true,
        nextRoute: "/privacy/secure/authorized-agent/delete/review"
      }
    });
  };

  render() {
    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    const { section_title, icontexts, buttons } = this.props.pageContent;

    return (
      <Container>
        <div style={{ maxWidth: "596px" }}>
        {/* DPCMP - 3792, 3791 */}
        <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    children: icontexts.length  ? icontexts.map(item => (
                        <Div key={item.text}>
                          {convertStringToElements(item.text)}
                        </Div>
                      ))
                      : null
                    }

               }}      
        />
          
          <Button background={buttons[0].type} style={{ marginTop: "16px" }} onClick={this.handleClick}>
            {buttons[0].text}
          </Button>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { delete_information: pageContent, breadCrumbs } }) => ({
  pageContent,
  breadCrumbs
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList }
  ),
  FetchPageContent
)(AuthorizedAgentDeleteInformation);

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }

  p strong {
    font-size: 20px;
    line-height: 19px;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ul {
    list-style: disc inside;
    margin: 15px 0;
  }
  
  li {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  }
`;
